import { v4 as uuidv4 } from "uuid";

const dataSlider = [
  {
    id: uuidv4(),
    title: "Osebest",
    subTitle: "I'm a Civil engineer turned Software engineer. And I love building building exciting user-friendly applications"
  },
  {
    id: uuidv4(),
    title: "My Mom",
    subTitle: "My sweet mother, my anchor and my reason for unwaning determination. I love you Mommma."
  },
  {
    id: uuidv4(),
    title: "My Favorite Aunt",
    subTitle: "Aunt Osi is my superhero. Always has the best intentions for me, and always has given me maximum support."
  },
  {
    id: uuidv4(),
    title: "My Darling",
    subTitle: "Tope... She's my angel, a blessing from above. She wants me to be the best, not just to want buh does everything within her power to see it happen. I love you dear."
  },
  {
    id: uuidv4(),
    title: "My Best Friends",
    subTitle: "Joshua and Chidinma, my priceless friends. Joshua always has my back, always and I so much appreciate him. Chii is an amazing friend, caring and loving, thank you for all you do."
  },
];

export default dataSlider;